import { Empty } from 'antd'
import CantileverCard from 'components/CantileverCard'
import { useLinkedQueries } from 'features/objectViews/hooks/useLinkedObjectQueries'
import React from 'react'
import { GeckoEntry } from 'types'

import { LinksSection } from './LinksSection'

interface ObjectLinksPanelProps {
  entry: GeckoEntry
}

export const ObjectLinksPanel: React.FC<ObjectLinksPanelProps> = ({
  entry,
}) => {
  const { parentQueries, childQueries } = useLinkedQueries(entry)

  const hasParentObjects = Object.keys(parentQueries).length > 0
  const hasChildObjects = Object.keys(childQueries).length > 0

  if (!hasParentObjects && !hasChildObjects) {
    return (
      <CantileverCard>
        <CantileverCard.Section topPadding bottomPadding>
          <Empty description='No linked objects found' />
        </CantileverCard.Section>
      </CantileverCard>
    )
  }

  return (
    <>
      {hasParentObjects && (
        <LinksSection
          title='Upward Links'
          typeToQuery={parentQueries}
          hasBottomMargin={hasChildObjects}
        />
      )}

      {hasChildObjects && (
        <LinksSection title='Downward Links' typeToQuery={childQueries} />
      )}
    </>
  )
}
